(() => {
  const template=document.getElementById('r2r-bundle-listing-template');
  if(!template)return;
  const pl=document.documentElement.lang==='pl';
  const listingUrl=new URL((pl?'/pl':'')+'/collections/all',location.origin);
  listingUrl.searchParams.set('preview_theme_id','209910759762');
  listingUrl.searchParams.set('r2r_bundle_listing','1');
  const link=document.createElement('a');link.href=listingUrl.href;link.textContent=pl?'Razem taniej':'Better together';
  document.querySelector('.r2r-demo-tools')?.append(link);
  if(new URLSearchParams(location.search).get('r2r_bundle_listing')!=='1'&&!document.querySelector('[data-r2r-listing-page]'))return;
  document.getElementById('MainContent')?.replaceChildren(template.content.cloneNode(true));
  const teeCards=document.getElementById('r2r-tee-listing-cards');
  if(teeCards){document.querySelector('.r2r-set-grid')?.append(teeCards.content.cloneNode(true));const count=document.querySelector('.r2r-set-count');if(count)count.textContent=pl?'6 zestawów':'6 sets';}
  if(window.R2RBundleCart?.enabled){
    document.querySelectorAll('.r2r-set-photo-1,.r2r-set-photo-3,.r2r-set-photo-4').forEach(photo=>{
      const card=photo.closest('.r2r-set-card'),badge=photo.querySelector('.r2r-set-badge');
      if(badge)badge.textContent=pl?'Przedsprzedaż mini':'Mini preorder';
      const note=document.createElement('p');note.className='r2r-set-card-options';note.textContent=photo.classList.contains('r2r-set-photo-1')?(pl?'Wysyłka zestawu od 10 listopada.':'Set ships from 10 November.'):(pl?"Dostępne rzeczy wyślemy od razu. Mini doślemy od 10 listopada Orlen Paczką na nasz koszt w Polsce. Punkt odbioru ustalimy przed wysyłką.":"In-stock items ship straight away. Your mini ships separately from 10 November via Orlen Paczka at our expense within Poland. We will confirm your pickup point before dispatch.");
      card.querySelector('.r2r-set-card-button')?.before(note);
    });
  }
  if(new URLSearchParams(location.search).get('r2r_display_test')==='1'){
    document.documentElement.classList.add('r2r-display-test');
    const note=document.createElement('p');note.className='r2r-display-test-note';
    note.textContent=pl?'Widok testowy: zdjęcia bez efektów graficznych.':'Display test: images without visual effects.';
    document.querySelector('.r2r-set-listing-header')?.after(note);
  }
  document.title=(pl?'Razem taniej':'Better together')+' | R2R'+(window.R2RBundleCart?.enabled?'':' | '+(pl?'Podgląd':'Preview'));
  document.querySelector('.r2r-set-listing')?.addEventListener('click',event=>{
    const target=event.target.closest('[data-r2r-set-open]');
    if(!target || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('r2r:fan-preview-open',{detail:{kind:target.dataset.r2rSetOpen}}));
  });
})();
